import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { ENavigationRoute } from "../model/enum/navigation-route";
import { CoreData } from "./core-data/core-data";

@Injectable()
export class ConfigurationGuard  {
    constructor(private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

        return !!this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanConfigureUser');
    }
}